import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError, retry, delay, scan, tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { throwError } from 'rxjs';
import { BASE_URL, END_POINTS } from 'src/app/utility/APIConstants';
@Injectable({ providedIn: 'root' })
export class ReportService {
  constructor(private _http: HttpClient) { }

  // users
  getAllUsers() {
    return this._http.get<any[]>(`${environment.apiBase}/api/user/getall`);
  }

  fetchStockTranscationEntries() {
    return this._http.get<any[]>(`${environment.apiBase}/stocktransaction/get`);
  }

  

  fetchStockTranscationEntriesByDate(startdate, enddate) {
    return this._http.get<any[]>(`${environment.apiBase}/stocktransaction/get?startDate=${startdate}&endDate=${enddate}`);
  }

  fetchwarehouseStockEntries() {
    return this._http.get<any[]>(`${environment.apiBase}/stock/get`);
  }

  fetchwarehouseStockEntries1() {
    return this._http.get<any[]>(`${environment.apiBase}/stock/warehousestock`);
  }

  fetchStockEntriesByWarehouse(warehouse:any) {
    return this._http.get<any[]>(`${environment.apiBase}/stock/warehousestock?warehouse=`+warehouse);
  }

  fetchBOQPRNSummary(id) {
    return this._http.get<any[]>(`${environment.apiBase}/reports/boq-prn-summary?siteKey=${id}`);
  }

  fetchBOQSummary(id) {
    return this._http.get<any[]>(`${environment.apiBase}/reports/boq-summary?siteKey=${id}`);
  }

  fetchPRNSummary(id) {
    return this._http.get<any[]>(`${environment.apiBase}/reports/prn-summary?prnKey=${id}`);
  }

  fetchBOQAmendmed(id) {
    return this._http.get<any[]>(`${environment.apiBase}/reports/boq-amendmend?siteKey=${id}`);
  }

  fetchBOQAmendmedByDate(id, from, to) {
    return this._http.get<any[]>(`${environment.apiBase}/reports/boq-amendmend?siteKey=${id}&from=${from}&to=${to}`);
  }

  fetchPOBySite(id) {
    return this._http.get<any[]>(`${environment.apiBase}/reports/po?siteKey=${id}`);
  }

  fetchPOByDate(from,id, to) {
    return this._http.get<any[]>(`${environment.apiBase}/reports/po?from=${from}&siteKey=${id}&to=${to}`);
  }

  fetchPendingGRNandDCBySite(limit:number,page: Number,id):Observable<any> {
    return this._http.get<any[]>(`${environment.apiBase}/reports/pending-grn-dc-report/${limit}/${page}?siteKey=${id}`);
  } 

  fetchPendingGRNandDCByDate(limit:number,page: Number,from,id, to):Observable<any> {
    return this._http.get<any[]>(`${environment.apiBase}/reports/pending-grn-dc-report/${limit}/${page}?from=${from}&siteKey=${id}&to=${to}`);
  }

  fetchGodownStock(){
    return this._http.get<any[]>(`${environment.apiBase}/reports/godown-stock`);
  }
  
  getBOQbyWO(workOrderNumber){
    return this._http.get<any[]>(`${environment.apiBase}/boqentry/get-by-work-order/${workOrderNumber}`);
  }

  fetchSiteWiseMaterialDetails(limit:number,page: Number,boqNo,id, woNo):Observable<any> {
    return this._http.get<any[]>(`${environment.apiBase}/reports/site-wise-material-details-report/${limit}/${page}?boqNo=${boqNo}&siteKey=${id}&workOrderNo=${woNo}`);
  }

  fetchSiteWisePlanningDetails(limit:number,page: Number,boqNo,id, woNo):Observable<any> {
    return this._http.get<any[]>(`${environment.apiBase}/reports/site-wise-planning-report/${limit}/${page}?boqNo=${boqNo}&siteKey=${id}&workOrderNo=${woNo}`);
  }

  fetchSitewiseStockReport(limit:number,page: Number,id):Observable<any> {
    return this._http.get<any[]>(`${environment.apiBase}/reports/site-wise-stock-report/${limit}/${page}?siteKey=${id}`);
  }
  
  fetchProductRateSummary(limit:number,page: Number,productName):Observable<any> {
    return this._http.get<any[]>(`${environment.apiBase}/reports/product-rate-summary-report/${limit}/${page}?productName=${productName}`);
  }

  fetchProductPurchaseSummary(limit:number,page: Number,):Observable<any> {
    return this._http.get<any[]>(`${environment.apiBase}/reports/product-purchase-summary-report/${limit}/${page}`);
  }

  fetchAditEntries() {
    return this._http.get<any[]>(`${environment.apiBase}/audittrail`);
  }

  fetchAditHistoryEntries(data:any) {
    return this._http.get<any[]>(`${environment.apiBase}/audittrail/getHistory?module=${data.module}&transactionNo=${data.transactionNo}`);
  }

  getExpenseReport(): Observable<any> {
      return this._http.get<any[]>(environment.apiBase + '/reports/expense-summary');
    }

  getOutstandingReport(id:any,params = {}): Observable<any> {
      return this._http.get<any[]>(environment.apiBase + `/reports/vendor-due/${id}`,{ params });
  }

    getSalesReport(): Observable<any> {
      return this._http.get<any[]>(environment.apiBase + '/reports/gst-report/SALES');
    }

    getPurchaseReport(): Observable<any> {
      return this._http.get<any[]>(environment.apiBase + '/reports/gst-report/PURCHASE');
    }

    getRetentionReport(): Observable<any> {
      return this._http.get<any[]>(environment.apiBase + `/reports/vendor-due/CONTRACTOR`,);
    }

  getTdsReport(): Observable<any> {
    return this._http.get<any[]>(environment.apiBase + `/reports/tds`,);
  }


  getSupplierOutstandingSummary(params: {
    supplierKey?: any;
    siteKey?: any;
    type?: string;
    fromDate?: string;
    toDate?: string;
    dueDate?: string;
  } = {}): Observable<any> {
    let httpParams = new HttpParams();
    Object.keys(params).forEach((key) => {
      const value = (params as any)[key];
      if (value !== undefined && value !== null && value !== '') {
        httpParams = httpParams.set(key, value);
      }
    });

    return this._http.get<any[]>(
      `${environment.apiBase}/reports/supplier-outstanding-summary`,
      { params: httpParams }
    );
  }

  exportSupplierOutstandingSummary(params: any = {}, format: 'pdf' | 'excel'): Observable<Blob> {
    let httpParams = new HttpParams();
    Object.keys(params).forEach((key) => {
      const value = params[key];
      if (value !== undefined && value !== null && value !== '') {
        httpParams = httpParams.set(key, value);
      }
    });

    const endpoint = format === 'pdf' ? 'export-pdf' : 'export-excel';
    return this._http.get(
      `${environment.apiBase}/reports/supplier-outstanding-summary/${endpoint}`,
      { params: httpParams, responseType: 'blob' }
    );
  }

  getProductWisePurchaseSummary(params: {
    siteKey?: any;
    supplierKey?: any;
    reportStatus?: string;
    reportGroup?: string;
    pageSize?: number;
    fromDate?: string;
    toDate?: string;
  } = {}): Observable<any> {
    let httpParams = new HttpParams();
    Object.keys(params).forEach((key) => {
      const value = (params as any)[key];
      if (value !== undefined && value !== null && value !== '') {
        httpParams = httpParams.set(key, value);
      }
    });

    return this._http.get<any[]>(
      `${environment.apiBase}/reports/product-wise-purchase-summary`,
      { params: httpParams }
    );
  }

  exportProductWisePurchaseSummary(params: any = {}, format: 'pdf' | 'excel'): Observable<Blob> {
    let httpParams = new HttpParams();
    Object.keys(params).forEach((key) => {
      const value = params[key];
      if (value !== undefined && value !== null && value !== '') {
        httpParams = httpParams.set(key, value);
      }
    });
    httpParams = httpParams.set('format', format);

    return this._http.get(
      `${environment.apiBase}/reports/product-wise-purchase-summary/export`,
      { params: httpParams, responseType: 'blob' }
    );
  }


  getSupplierLedgerReport(params: {
    supplierKey?: any;
    fromDate?: string;
    toDate?: string;
  } = {}): Observable<any> {
    let httpParams = new HttpParams();
    Object.keys(params).forEach((key) => {
      const value = (params as any)[key];
      if (value !== undefined && value !== null && value !== '') {
        httpParams = httpParams.set(key, value);
      }
    });

    return this._http.get<any[]>(
      `${environment.apiBase}/reports/supplier-ledger`,
      { params: httpParams }
    );
  }

  exportSupplierLedgerReportPdf(params: any = {}): Observable<Blob> {
    let httpParams = new HttpParams();
    Object.keys(params).forEach((key) => {
      const value = params[key];
      if (value !== undefined && value !== null && value !== '') {
        httpParams = httpParams.set(key, value);
      }
    });

    return this._http.get(
      `${environment.apiBase}/reports/supplier-ledger/export-pdf`,
      { params: httpParams, responseType: 'blob' }
    );
  }

  getSupplierLedgerHeader(supplierKey: string | number): Observable<any> {
    let httpParams = new HttpParams().set('supplierKey', String(supplierKey));

    return this._http.get<any>(
      `${environment.apiBase}/reports/supplier-ledger/header`,
      { params: httpParams }
    );
  }

}
